import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {
  LoginComponent, RegisterComponent, DashboardComponent, ForgotComponent,
  RecoveryComponent, AccountInfoComponent, MainContentComponent, RegistrationComponent, ExpressSignupComponent
} from './pages';
import { DashboardReportComponent } from './pages/dashboard/components';

import {
  AdjustmentsComponent, BarriersEntryComponent,
  SpecialConsiderationComponent,
  ManagerSalaryComponent,
  PersonalGoodwillComponent,
  ProjectionTableComponent, RecurringRevenueComponent,
  RentDetailsComponent, ReplacementSalaryComponent, ReportComponent, RequiredInformationComponent,
  ConclusionComponent,
  WeightingTableComponent,
  SuccessPageComponent,
  CheckoutComponent,

  // alternative flow
  OverviewComponent,
  LocationComponent,
  OwnershipComponent,
  AssetsLiabilitiesComponent,
  DiversificationComponent,
  IncomeComponent,
  FutureProjectionsComponent
} from './pages/report'

import { PricingPlansComponent, TransactionsHistoryComponent } from './pages/payment';

import { SignupComponent } from './pages/signup/signup.component';
import {PageNotFoundComponent} from './pages/page-not-found/page-not-found.component';
import {canActivateAuthGuard} from './guards/auth.guard';
import {canDeactivateFormValidationGuard} from './guards/form-validation.guard';


const routes: Routes = [
  { // Default to Dashboard
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  { // Login
    path: 'login',
    component: LoginComponent
  },
  { // Register
    path: 'register',
    component: RegisterComponent
  },
  { // Org User Register
    path: ':name/register',
    component: RegistrationComponent
  },
  { // signup
    path: 'signup',
    component: SignupComponent
  },
  /*{ // signup
    path: 'express_signup',
    component: ExpressSignupComponent
  },*/
  { // Forgot
    path: 'forgot',
    component: ForgotComponent
  },
  { // Recovery
    path: 'recovery',
    component: RecoveryComponent
  },
  {
    path: '',
    component: MainContentComponent,
    canActivate: [canActivateAuthGuard],
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [canActivateAuthGuard]
      },
      {
        path: 'dashboard-report',
        component: DashboardReportComponent,
        canActivate: [canActivateAuthGuard]
      },
      { // Account Info
        path: 'account-setting',
        component: AccountInfoComponent
      },
      { // Report
        path: 'report/:id',
        component: ReportComponent,
        canActivateChild: [canActivateAuthGuard],
        children: [
          //#region "Overview"
          {
            path: 'overview',
            component: OverviewComponent,
            canDeactivate: [canDeactivateFormValidationGuard]
          },
          //#endregion

          //#region "Special-Consideration"
          {
            path: 'special-consideration',
            component: SpecialConsiderationComponent,
            canDeactivate: [canDeactivateFormValidationGuard]
          },
          //#endregion

          //#region "Location"
          {
            path: 'location',
            component: LocationComponent,
            canDeactivate: [canDeactivateFormValidationGuard]
          },
          //#endregion

          //#region "ownership"
          {
            path: 'ownership',
            component: OwnershipComponent,
            canDeactivate: [canDeactivateFormValidationGuard]
          },
          //#endregion

          //#region "income"
          {
            path: 'income',
            component: IncomeComponent,
            canDeactivate: [canDeactivateFormValidationGuard]
          },
          //#endregion

          //#region "income"
          {
            path: 'future-projection',
            component: FutureProjectionsComponent,
            canDeactivate: [canDeactivateFormValidationGuard]
          },
          //#endregion

          //#region "rent"
          {
            path: 'rent/rent-details',
            component: RentDetailsComponent,
            canDeactivate: [canDeactivateFormValidationGuard]
          },
          //#endregion

          //#region "salary"
          {
            path: 'salary/manager-salary',
            component: ManagerSalaryComponent,
            canDeactivate: [canDeactivateFormValidationGuard]
          },
          {
            path: 'salary/replacement-salary',
            component: ReplacementSalaryComponent,
            canDeactivate: [canDeactivateFormValidationGuard]
          },
          //#endregion

          //#region "projections"
          {
            path: 'projections/projection-table',
            component: ProjectionTableComponent,
            canDeactivate: [canDeactivateFormValidationGuard]
          },
          //#endregion

          //#region "assets / liabilities"
          {
            path: 'assets-liabilities',
            component: AssetsLiabilitiesComponent,
            canDeactivate: [canDeactivateFormValidationGuard]
          },
          //#endregion

          //#region "adjustments"
          {
            path: 'adjustments',
            component: AdjustmentsComponent,
            canDeactivate: [canDeactivateFormValidationGuard]
          },
          //#endregion

          //#region "weighting"
          {
            path: 'weighting/weighting-table',
            component: WeightingTableComponent,
            canDeactivate: [canDeactivateFormValidationGuard]
          },
          //#endregion

          //#region "Risk"
          {
            path: 'risk/diversification',
            component: DiversificationComponent,
            canDeactivate: [canDeactivateFormValidationGuard]
          },
          {
            path: 'risk/personal-goodwill',
            component: PersonalGoodwillComponent,
            canDeactivate: [canDeactivateFormValidationGuard]
          },
          {
            path: 'risk/barriers-entry',
            component: BarriersEntryComponent,
            canDeactivate: [canDeactivateFormValidationGuard]
          },
          {
            path: 'risk/recurring-revenue',
            component: RecurringRevenueComponent,
            canDeactivate: [canDeactivateFormValidationGuard]
          },
          //#endregion

          //#region "Conclusion"
          {
            path: 'conclusion',
            component: ConclusionComponent,
            canDeactivate: [canDeactivateFormValidationGuard]
          },
          //#endregion

        ]
      },
      //#region "Payment"
      { // "Payment/pricing"
        path: 'payment/pricing',
        component: PricingPlansComponent
      },
      { // "Payment/checkout"
        path: 'report/payment/checkout/:type/:id',
        component: CheckoutComponent
      },
      { // "Payment/checkout"
        path: 'report/payment/checkout/:type',
        component: CheckoutComponent
      },
      { // "Payment/success"
        path: 'report/payment/success',
        component: SuccessPageComponent
      },
      { // "Payment/transactions-history"
        path: 'payment/transactions-history',
        component: TransactionsHistoryComponent
      },
      //#endregion
      { // "reportIntroduction"
        path: 'report/introduction/required-information',
        component: RequiredInformationComponent
      },
      {
        path: 'express-value',
        loadChildren: () => import('./modules/quick-report/quick-report.module').then(m => m.QuickReportModule)
      },
      {
        path: 'administrator-settings',
        loadChildren: () => import('./modules/administrator-settings/administrator-settings.module').then(m => m.AdministratorSettingsModule)
      },
      {
        path: 'org-settings',
        loadChildren: () => import('./modules/org-settings/org-settings.module').then(m => m.OrgSettingsModule)
      }
    ]
  },
  {
    path: 'download-released',
    loadChildren: () => import('./modules/outside-app/outside-app.module').then(m => m.OutsideAppModule)
  },
  { // 404
    path: 'page-not-found',
    component: PageNotFoundComponent
  },
  { // Default
    path: '**',
    redirectTo: 'page-not-found',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
